import request from '@/utils/request';

const PATH = '/stay/room/special/price';

export const getStayRoomSpecialPriceList = (params: any) => request({
  url: PATH,
  method: 'get',
  params: {
    ...params,
    page: params.page - 1,
  },
});

export const getStayRoomSpecialPrice = (idx: any) => request({
  url: `${PATH}/${idx}`,
  method: 'get',
});

export const addStayRoomSpecialPrice = (data: any) => request({
  url: PATH,
  method: 'post',
  data,
});

export const updateStayRoomSpecialPrice = (idx: any, data: any) => request({
  url: `${PATH}/${idx}`,
  method: 'put',
  data,
});

export const deleteStayRoomSpecialPrice = (idx: any) => request({
  url: `${PATH}/${idx}`,
  method: 'delete',
});
